import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { MatPaginator, MatSort } from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../core/service/common-service/common.service';
import * as _moment from 'moment';
import { tableData } from './tableData';

@Component({
  selector: 'app-pipeline-enquiry-table',
  templateUrl: './pipeline-enquiry-table.component.html',
  styleUrls: ['./pipeline-enquiry-table.component.scss'],
})

export class PipelineEnquiryTableComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true })  paginator: MatPaginator;

  displayedColumns: string[] = [
    'vin',
    'productType',
    'enquiryId',
    'message',
  ];
  dataSource: any;
  dataSource1:any;
  listSize: number = 0;
  pageSize: number = 5;;

  ngOnInit() {}

  constructor(private commonService: CommonService, private dialogRef: MatDialogRef<PipelineEnquiryTableComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, public router: Router) {
    this.listSize =this.data.data.length;
    this.dataSource1=data.data
  }

  ngAfterViewInit(){
    this.dataSource = new MatTableDataSource<tableData>(this.dataSource1);
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (data, header) => data[header];
    this.dataSource.paginator = this.paginator;
  }

  okResponse() {
    this.router.navigate(['pipeline-management']);
    this.dialogRef.close();
  }
}

export function openPipelineEnquiryTableDialog(dialog: MatDialog, data: any) {
  const config = new MatDialogConfig();
  config.disableClose = true;
  config.autoFocus = true;
  config.width = '900px';
  config.height = '450px';
  config.data = {
    data: data
  }
  const dialogRef = dialog.open(PipelineEnquiryTableComponent, config);
  return dialogRef.afterClosed();
}
